<template>
  <span v-if="def">
    <template v-if="isDb">
      <UiDbSpan tag="span" :id="value" />
    </template>
    <template v-else-if="isCode">
      <span :title="lcdesc(code, value)">{{ lc(code, value) }}</span>
    </template>
    <template v-else-if="isTag">
      <UiTagSpan :id="value" notag>
        <template v-slot="{ label }">{{ ls(label) }}</template>
      </UiTagSpan>
    </template>
    <template v-else-if="isProvider">
      <UiOrgProviderSpan :id="value" />
    </template>
    <template v-else-if="isOrg">
      <UiOrgSpan :id="value" />
    </template>
    <template v-else-if="isContents">
      <span>{{ ls(contentsCodeLang[value]) }}</span>
    </template>
    <template v-else-if="isPrefectures">
      <span>{{ ls(getPrefecture(value).name) }}</span>
    </template>
    <template v-else-if="isEra">
      <span>{{ ls(getEra(value).name) }}</span>
    </template>
    <template v-else>{{ value }}</template>
  </span>
</template>

<script lang="ts" setup>
import { useSearchField } from '~/components/search/useSearchField'

const { lcdesc, ls, lc } = useI18n()
const { $getContentsCodeLang } = useNuxtApp()
const { getEra, getPrefecture } = useSearchField()

interface Props {
  facet: ItemFacet
  def: CustomSearchField
  value: string
}
const props = withDefaults(defineProps<Props>(), {})
const dataStore = useDataStore()

const contentsCodeLang: {} = $getContentsCodeLang()

const code = computed(() => {
  if (isCode.value) return dataStore.code(props.def.codeKey)
  else return null
})

const isCode = computed(() => {
  return props.def.type === 'code'
})

const isDb = computed(() => {
  return props.def.type === 'database'
})

const isProvider = computed(() => {
  return props.def.type === 'provider'
})

const isContents = computed(() => {
  return props.def.type === 'contents'
})

const isOrg = computed(() => {
  return props.def.type === 'organization'
})

const isTag = computed(() => {
  return props.def.type === 'tag'
})

const isPrefectures = computed(() => {
  return props.def.type === 'prefectures'
})

const isEra = computed(() => {
  return props.def.type === 'temporal'
})
</script>

<style lang="scss">
</style>
